// extracted by mini-css-extract-plugin
module.exports = {"userMenu":"HeaderMenu_userMenu__3kcdr","rightMenu":"HeaderMenu_rightMenu__2pyv1"};